import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.5921 0L29.0647 10.6662V28.2662C29.0647 30.3286 27.4241 32 25.3993 32H6.54841C4.52361 32 2.88281 30.3272 2.88281 28.2662V3.73376C2.88297 1.67136 4.52377 0 6.54857 0H18.5921Z",
      fill: "#FD7541"
    }, null, -1),
    _createElementVNode("path", {
      d: "M29.0647 10.6662H22.4423C20.4189 10.6662 18.592 8.8072 18.592 6.74464V0L29.0647 10.6662Z",
      fill: "white",
      "fill-opacity": "0.4"
    }, null, -1),
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M12.9774 14.1077C10.2952 14.1077 8.12207 16.3214 8.12207 19.0517C8.12207 21.7817 10.2966 23.9957 12.9774 23.9957C15.6581 23.9957 17.8326 21.7817 17.8326 19.0501H12.9776V14.1077H12.9774Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.7339 13.3352V18.2808H18.5876C18.5876 15.5491 16.4145 13.3352 13.7324 13.3352H13.7339Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }